import { useCallback, useMemo, type FC } from 'react'
import classNames from 'classnames'
import { Fade } from 'react-awesome-reveal'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Text } from 'components'
import { getProject, portfolioImg, resolveLang } from 'pages/Portfolio/portfolioCatalog'

import { featuredSlugs } from './utils'
import styles from './Activity.module.scss'

const Activity: FC = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const lang = resolveLang(i18n.language)

  const projects = useMemo(
    () =>
      featuredSlugs
        .map(getProject)
        .filter((p): p is NonNullable<typeof p> => Boolean(p))
        .map(p => ({ slug: p.slug, title: p.name[lang] || p.name.am, url: portfolioImg(p.slug, p.cover) })),
    [lang]
  )

  const handleSeeAll = useCallback(() => {
    navigate('/portfolio')
  }, [navigate])

  return (
    <div className={styles.activityContainer}>
      <div className={classNames('container', styles.activity)}>
        <div className={styles.head}>
          <div className={styles.head__block}>
            <div className={styles.head__block_title}>
              <Text text={'activity'} className={styles.head__block_title_services} tagName='h2' />
            </div>
          </div>
          <Text className={styles.head__description} text='activityText' />
          <ul className={styles.head__description__list}>
            <li>
              <Text className={styles.head__description__list__item} text='activityText1' />
            </li>
            <li>
              <Text className={styles.head__description__list__item} text='activityText2' />
            </li>
            <li>
              <Text className={styles.head__description__list__item} text='activityText3' />
            </li>
          </ul>
        </div>

        <div className={styles.grid}>
          {projects.map((project, index) => (
            <Fade
              key={project.slug}
              triggerOnce
              delay={index * 100}
              className={classNames(styles.card, { [styles.card_featured]: index === 0 })}
            >
              <Link to={`/portfolio/${project.slug}`} className={styles.card__link} aria-label={project.title}>
                <img src={project.url} alt={project.title} className={styles.card__image} loading='lazy' />
                <div className={styles.card__overlay} />
                <div className={styles.card__content}>
                  <h3 className={styles.card__title}>{project.title}</h3>
                </div>
              </Link>
            </Fade>
          ))}
        </div>

        <div className={styles.footerCta}>
          <button className={styles.footerCta__button} onClick={handleSeeAll}>
            <Text text={'seeAll'} />
            <span className={styles.footerCta__arrow} aria-hidden />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Activity
